import { Utils } from '../../../shared/constants/utilities.constants';

export class BuildingSiteFormViewModel {
    public name: string;
    public code?: string;
    public street: string;
    public buildingNumber?: string;
    public country: string;
    public countryId: string;
    public postalCode: string;
    public city: string;
    public comment?: string;
    public countryName?: string;
    public contactId?: string;
    public addressId?: string;
    constructor() {
        this.name = '';
        this.street = '';
        this.country = '';
        this.countryId = Utils.defaultUuid;
        this.postalCode = '';
        this.city = '';
    }
}
